export default "__VITE_ASSET__BYbitQgn__"